/* eslint-disable max-len */
import { GamesTranslations } from '../interfaces/games';

// Reguły gier wymieniają przyciski ich nazwami z `buttons` — przy zmianie nazwy przycisku poprawić też reguły
const EnglishGamesTranslations: GamesTranslations = {
  names: {
    repeat: 'Repeat',
    find: 'Find',
    pick: 'Pick',
    pairing: 'Pair',
    memory: 'Memory',
    recognize: 'Recognise the word',
    recognize2: 'Recognise the translation',
    recognizeEasy: 'Read it and say what it means',
    recognize2Easy: 'Say it in English',
    dragLetters: 'Build the words',
    writing: 'Write',
    letters: 'Spell',
  },
  buttons: {
    go: 'GO',
    pause: 'PAUSE',
    sound: 'listen',
    skip: 'SKIP',
    next: 'NEXT',
    check: 'CHECK',
    clear: 'CLEAR',
    repeat: 'REPEAT',
    correct: 'CORRECT',
    iWasRight: 'I WAS RIGHT',
    iWasRightEasy: 'I was right',
    repeatGame: 'REPEAT GAME',
    nextGame: 'NEXT GAME',
    rules: 'Game rules',
    editList: 'Edit the whole list',
    editTerm: 'Edit the phrase',
    spell: 'SPELL',
  },
  labels: {
    skipWord: 'Skip the word',
    clearAndRetry: 'Clear and try again',
    iWasRightNext: 'I was right — next word',
    repeatWord: 'Repeat the word',
    nextWord: 'Next word',
    playWord: 'Play the word',
    readPolish: 'Read in Polish',
    readEnglish: 'Read in English',
    letterSlot: 'Position {{n}}',
    moreOptions: 'More options',
    markRightWord: 'Mark the right word',
    choose: 'Choose',
    wordImage: 'word image',
    cardImage: 'card image',
  },
  states: {
    loadingList: 'Loading the list...',
    noActiveList: 'No active list',
    chooseList: 'Choose a word list to start the game',
    backToLists: 'Back to lists',
    dataError: 'Data error',
    wordLoadError: 'Could not load the word',
    noWords: 'There are no words in the list.',
  },
  writingPlaceholder: 'type the translation',
  choosePicture: 'Click the right picture:',
  polishNarrator: {
    label: 'Polish narrator: ',
    on: 'on',
    off: 'off',
  },
  audioError: 'No connection to the narrator — the game goes on without sound.',
  rules: {
    repeat: {
      title: 'REPEAT module: ',
      items: [
        'Press the GO button to see and hear all the words on the list, one by one. The items appear in a random order in every game.',
        'The narrator reads each word in English. If the Polish narrator is switched on in the game options, it also reads the Polish meaning before the English word.',
        'After each word or sentence there is a moment of silence. Repeat it out loud in English before the next one appears.',
        'You can stop the presentation at any time with the PAUSE button. When you start again, the word is repeated before the next word from the list is shown.',
        'When the list is finished, you can play it all again if you need to — especially if you are just starting to learn the list or find it difficult.',
      ],
    },
    find: {
      title: 'FIND module: ',
      items: [
        'Recognise by its pronunciation which word from the list has been read out. If you did not hear it, play it again with the LISTEN button.',
        'Click the picture that matches this word. Under the pictures you can see their Polish meanings.',
        'If your choice was correct, the next word appears. If not, the narrator reads the word from the clicked picture in English — try again.',
        'If the Polish narrator is switched on in the game options, after every click on a picture the narrator also reads its Polish meaning.',
        'INFO: A mistake makes the word appear again at the end of the game.',
      ],
    },
    findEasy: {
      title: 'FIND module: ',
      items: [
        'Recognise by its pronunciation which word from the list has been read out. If you did not hear it, play it again with the LISTEN button.',
        'Click the picture that matches this word.',
        'The speaker in the corner of a picture reads its Polish meaning. Clicking the speaker is not an answer.',
        'If your choice was correct, the next word appears. If not, the narrator reads the word from the clicked picture in English — try again.',
        'If the Polish narrator is switched on in the game options, after every click on a picture the narrator also reads its Polish meaning.',
        'INFO: A mistake makes the word appear again at the end of the game.',
      ],
    },
    pick: {
      title: 'PICK module: ',
      items: [
        'Click the word that matches the picture you see. Under the picture you can see its Polish meaning.',
        'After every click the narrator reads the chosen word in English and — if the Polish narrator is switched on in the game options — in Polish too.',
        'If your choice was correct, the next picture appears. If not, try again.',
        'INFO: A mistake makes the word appear again at the end of the game.',
      ],
    },
    pickEasy: {
      title: 'PICK module: ',
      items: [
        'Click the word that matches the picture you see.',
        'The speaker in the corner of the picture reads the word you are looking for in English — use it if you do not remember. Clicking the speaker is not an answer.',
        'After every click on a word the narrator reads it in English and — if the Polish narrator is switched on in the game options — in Polish too.',
        'If your choice was correct, the next picture appears. If not, try again.',
        'INFO: A mistake makes the word appear again at the end of the game.',
      ],
    },
    pairing: {
      title: 'PAIR module: ',
      items: [
        'Tags with words/phrases and pictures are scattered all over the board. You can move both.',
        'Your task is to drag a TAG with a phrase ONTO the matching picture — about a third of the tag has to be on the picture.',
        'A clicked picture turns over for a moment and shows the Polish meaning.',
        'If your choice was correct, the narrator reads the word in English (and in Polish, if the Polish narrator is switched on in the game options), and then the pair disappears. If not, keep trying.',
        'The goal is to remove all the word tags.',
        'INFO: If the list has more than 10 items, the cards are split into smaller groups.',
      ],
    },
    pairingEasy: {
      title: 'PAIR module: ',
      items: [
        'Tags with words/phrases and pictures are scattered all over the board. You can move both.',
        'Your task is to drag a TAG with a phrase ONTO the matching picture — about a third of the tag has to be on the picture.',
        'When you click a picture, the narrator reads its Polish meaning.',
        'If your choice was correct, the narrator reads the word in English (and in Polish, if the Polish narrator is switched on in the game options), and then the pair disappears. If not, keep trying.',
        'The goal is to remove all the word tags.',
        'INFO: If the list has more than 5 items, the cards are split into smaller groups.',
      ],
    },
    memory: {
      title: 'MEMORY module: ',
      items: [
        'This is the classic memory game: clicking an item turns the card over.',
        'Half of the cards are pictures and half are cards with English words. A turned-over picture says its word in English; a word card makes no sound.',
        'The goal is to turn over all the matching word–picture pairs. A correct match takes those items out of the game.',
        'INFO: If the list has more than 9 items, the cards are split into smaller groups.',
      ],
    },
    memoryEasy: {
      title: 'MEMORY module (Easy): ',
      items: [
        'This is the classic memory game: clicking a card turns it over.',
        'Half of the cards are pictures and half are sound cards marked with a speaker. The game shows no words.',
        'A turned-over speaker card says its word in English. A picture makes no sound.',
        'The goal is to find sound–picture pairs: a speaker card and the picture that shows the same word. A pair you find leaves the game.',
        'When you find a pair, the narrator reads the Polish translation of the word — if the Polish narrator is switched on in the game options.',
        'INFO: If the list has more than 4 words, the cards are split into groups of 4 pairs. If needed, the last group is filled up with words from the earlier ones, so some pairs appear a second time.',
      ],
    },
    recognize: {
      title: 'RECOGNISE THE WORD module: ',
      items: [
        'If you recognise the meaning of the word shown, great. Click the CORRECT button to see the next one.',
        'If you do not recognise the word, or you are not sure, click the tag with the “?” sign: the translation appears and the narrator reads the word in English (and in Polish, if the Polish narrator is switched on in the game options). Clicking the translation covers it again.',
        'If you want to see the word once more, click the REPEAT button. The game moves on to the next word, and this one appears again near the end of the game.',
        'INFO: At the last word of the list the REPEAT button changes its look. If you use it then, one more, different word from the list appears before the repetition.',
      ],
    },
    recognizeEasy: {
      title: 'READ IT AND SAY WHAT IT MEANS module: ',
      items: [
        'Read the word shown and say what it means. If you know, click the CORRECT button to see the next one.',
        'If you do not know, or you are not sure, click the tag with the “?” sign: a picture appears (or the Polish translation, if the word has no picture) and the narrator reads the word in English (and in Polish, if the Polish narrator is switched on in the game options). Clicking the picture covers it again.',
        'If you want to see the word once more, click the REPEAT button. The game moves on to the next word, and this one appears again near the end of the game.',
        'INFO: At the last word of the list the REPEAT button changes its look. If you use it then, one more, different word from the list appears before the repetition.',
      ],
    },
    recognize2: {
      title: 'RECOGNISE THE TRANSLATION module: ',
      items: [
        'A word in Polish appears on the screen. If the Polish narrator is switched on in the game options, the narrator reads it.',
        'If you remember the EXACT equivalent of the word in the foreign language, great. Click the CORRECT button to see the next one.',
        'If you do not remember — or you are not sure — click the tag with the “?” sign: the answer appears and the narrator reads it in English. Clicking the answer covers it again.',
        'If you want to see the word once more, click the REPEAT button. The game moves on to the next word, and this one appears again near the end of the game.',
        'INFO: At the last word of the list the REPEAT button changes its look. If you use it then, one more, different word from the list appears before the repetition.',
      ],
    },
    recognize2Easy: {
      title: 'SAY IT IN ENGLISH module: ',
      items: [
        'A picture and a word in Polish appear on the screen. If the Polish narrator is switched on in the game options, the narrator reads the word.',
        'Say this word in English. If you remember it EXACTLY, great. Click the CORRECT button to see the next one.',
        'If you do not remember — or you are not sure — click the tag with the “?” sign: the answer appears and the narrator reads it in English. Clicking the answer covers it again.',
        'If you want to see the word once more, click the REPEAT button. The game moves on to the next word, and this one appears again near the end of the game.',
        'INFO: At the last word of the list the REPEAT button changes its look. If you use it then, one more, different word from the list appears before the repetition.',
      ],
    },
    writing: {
      title: 'WRITE module: ',
      items: [
        'The last and most engaging task: type the translation of the word shown, in the foreign language. Press ENTER to confirm. If you get it right, the next word appears.',
        'If the Polish narrator is switched on in the game options, the narrator reads each new word in Polish.',
        'A mistake brings up the correct answer and the CLEAR and I WAS RIGHT buttons. Press ENTER (or click CLEAR) to empty the box and try again — the word will then also come back near the end of the game.',
        'The SKIP button skips the word and goes straight to the next one. It disappears when you press ENTER.',
        'Typing all the words from the list correctly means you have mastered the list. CONGRATS!!!',
        'INFO: Letter case, the number of spaces and punctuation do not matter. A contraction counts as the full form (I’ll = I will), and sb, someone and somebody are the same. You can leave out the articles a, an, the and “to” at the beginning, as well as anything in brackets in the answer. If the answer has several variants separated by a slash, type all of them — in any order.',
        'TIP: If it is just a typo or another small mistake, you can use the I WAS RIGHT button — the game moves on to the next word and this one does not come back near the end of the game (of course we advise against overusing it, so that the game stays effective).',
      ],
    },
    writingEasy: {
      title: 'WRITE module: ',
      items: [
        'The last and most engaging task: type the translation of the word shown, in the foreign language. Press ENTER to confirm. If you get it right, the narrator reads the word in English and the next one appears.',
        'If the Polish narrator is switched on in the game options, the narrator reads each new word in Polish.',
        'A mistake brings up the correct answer and the CLEAR and I WAS RIGHT buttons. Press ENTER (or click CLEAR) to empty the box and try again — the word will then also come back near the end of the game.',
        'The SKIP button skips the word and goes straight to the next one. It disappears when you press ENTER.',
        'Typing all the words from the list correctly means you have mastered the list. CONGRATS!!!',
        'INFO: Letter case, the number of spaces and punctuation do not matter. A contraction counts as the full form (I’ll = I will), and sb, someone and somebody are the same. You can leave out the articles a, an, the and “to” at the beginning, as well as anything in brackets in the answer. If the answer has several variants separated by a slash, type all of them — in any order.',
        'TIP: If it is just a typo or another small mistake, you can use the I WAS RIGHT button — the game moves on to the next word and this one does not come back near the end of the game (of course we advise against overusing it, so that the game stays effective).',
      ],
    },
    letters: {
      title: 'SPELL module: ',
      items: [
        'The program says the letters of a word one by one. Your task is to click the right letter among the scattered letters. The LISTEN button repeats the letter you are looking for.',
        'If you choose a wrong letter, it lights up red and you hear the letter you are looking for once more. Try again to find the right letter.',
        'When the whole word is built, you will see 3 pictures (2 if the list has two words). Click the one that matches the word.',
        'If you click a wrong picture, it lights up red and the built word appears above the pictures. Try again.',
        'At the end the program spells the word (each letter separately) and says the whole word. You can play it again with the REPEAT button, and the NEXT button takes you to the next word.',
        'The SKIP button skips the word and goes straight to the next one.',
        'TIP: Listen carefully — every letter has its own sound! This will help you remember the pronunciation better.',
      ],
    },
    dragLetters: {
      title: 'BUILD THE WORDS module: ',
      items: [
        'You will see a picture of the word to build and scattered letters. The LISTEN button reads the word in English.',
        'Drag the letters onto the empty boxes to build the correct word. Characters that are not letters (e.g. an apostrophe or a hyphen) are already in place.',
        'You can swap letters — drag one letter onto a box taken by another one to swap them.',
        'When all the letters are in place, click the CHECK button to check your answer.',
        'If you build the word correctly, you will see a confirmation and the NEXT button for the next word.',
        'If you build the word incorrectly, you will see the correct version. Click CLEAR to empty the boxes and try again.',
        'Words with mistakes will come back later in the game.',
        'The SKIP button skips the word and goes straight to the next one. A skipped word will not come back.',
        'TIP: Look at the picture — it will help you understand which word to build!',
      ],
    },
  },
};

export default EnglishGamesTranslations;
